class SharedQueryKeys {
    prefix = 'shared';
    getSharedItems(params) {
        return [this.prefix, params].filter(Boolean);
    }
}
export default SharedQueryKeys;
